import { $, $$, breakpoint, setElementFocus } from 'dlr-utils/helpers';
import smoothscroll from 'smoothscroll-polyfill';

/**
 * IMPORTANT: THIS WILL ALWAYS BE AN ARRAY
 * Always make it possible for multiple instances
 * of your module to work on the pages.
 */
const SELECTOR = '.dlr-storyscape';
const INSTANCES = $$(SELECTOR);

/* If you want to target just one, just uncomment the line below */
// const ELEMENT = SELECTOR[0];

/**
 * 1. Mounting
 *
 * Put module-specific variables and functions here.
 * Actions in this scope will fire as soon as the module
 * is mounted (not yet attached to the page)
 *  e.g. setting of initial states (see below), data fetching, etc
 *
 * The default export functions are the only
 * ones used by the dynamic module importer (main.js).
 * upon page load. main.js will only fire these if
 * at least one element with the class ".dlr-storyscape" exists
 */
const IS_SCROLL_END = '--is-scroll-end';
const IS_SCROLLTO = '--is-scroll-to';
const IS_VERTICAL_SCROLLTO = '--is-vertical-scroll-to';
const IS_ACTIVE = '--is-active';

const dropdown = $$(`${SELECTOR}__navigation-dropdown select`);
const navItems = $$(`${SELECTOR}__navigation a`);
const skipBtn = $$(`${SELECTOR}__navigation-skip-button`);
const mediaItems = [...$$(`${SELECTOR}__media`)];

let isScrolling;
let isVerticalScrolling;
let previousActiveId;

export default {
  /**
   * 2. REGISTRATION
   *
   * Use `init` for actions that should fire as soon as
   * the module file has been made available to the page
   *  - e.g. data transformations, MessageBus Subscriptions
   */
  init(GlobalEvents, MessageBus) {
    const { onScroll, onResize, debounced } = GlobalEvents;

    const getNavTop = (module) => {
      const nav = $$(`${SELECTOR}__navigation`, module)[1];
      const navTop = parseInt(getComputedStyle(nav).top.replace('px', ''));

      return breakpoint() == 'desktop' ? navTop : 0;
      // return navTop;
    }

    /*
      Set Active Nav Item helper
    */
    const setActiveNavItem = (module, id) => {
      const targetItem = $(`${SELECTOR}__navigation-items a[data-nav-id="${id}"]`, module);
      const previousActiveItem = $(`${SELECTOR}__navigation-items a.${IS_ACTIVE}`, module);
      const dropdown = $(`${SELECTOR}__navigation-dropdown select`, module);
      const dropdownLabel = $(`${SELECTOR}__navigation-dropdown label`, module);
      const dropdownText = $(`option[value="${id}"]`, dropdown).getAttribute('data-label');

      if (targetItem) {
        previousActiveItem.classList.remove(IS_ACTIVE);
        targetItem.classList.add(IS_ACTIVE);

        dropdown.value = id;
        dropdownLabel.innerHTML = dropdownText;

        MessageBus.publish('NAV_VERTICAL_SCROLL_POSITION_HANDLER', { target: targetItem, id: id });
      }
    }

    /*
      NAV DROPDOWN HANDLER | onChange Event
    */
    MessageBus.subscribe('NAV_DROPDOWN_HANDLER', event => {
      const { target } = event;
      const module = target.closest(SELECTOR);

      MessageBus.publish('SCROLLTO_SECTION_HANDLER', { target: target, id: target.value });
    });



    /*
      NAV VERTICAL SCROLL HANDLER for Tablet Breakpoint
    */
    MessageBus.subscribe('NAV_VERTICAL_SCROLL_HANDLER', ({ module }) => {
      const listsContainer = $(`${SELECTOR}__navigation-items`, module);

      const isScrollable = () => {
        const scrollWidth = (listsContainer.scrollWidth - 2);
        const { scrollLeft, offsetWidth } = listsContainer;
        const isScrollEnd = scrollWidth - scrollLeft <= offsetWidth;

        isScrollEnd ?
          module.classList.add(IS_SCROLL_END) :
          module.classList.remove(IS_SCROLL_END);
      }


      setTimeout(isScrollable, 100);
      onResize(resizeEvent => isScrollable());
      listsContainer.addEventListener('scroll', event => isScrollable());
    });

    MessageBus.subscribe('NAV_VERTICAL_SCROLL_POSITION_HANDLER', ({ target, id }) => {
      if (breakpoint() != 'tablet') return;

      const parent = target.closest(`${SELECTOR}__navigation-items`);
      const parentWidth = parent.clientWidth - 50;

      const inView = parentWidth > (target.offsetLeft + target.offsetWidth) - parent.scrollLeft && parent.scrollLeft <= target.offsetLeft;

      if ( !inView && previousActiveId != id) {
        let targetLeft = 0;

        clearTimeout(isVerticalScrolling);
        parent.classList.add(IS_VERTICAL_SCROLLTO);
        isVerticalScrolling = setTimeout(() => parent.classList.remove(IS_VERTICAL_SCROLLTO), 200);


        if (parent.scrollLeft <= target.offsetLeft) {
          targetLeft = target.offsetLeft + target.offsetWidth - parentWidth
        } else {          
          targetLeft = target.offsetLeft
        }


        parent.scroll({
          left: targetLeft,
          behavior: 'smooth'
        });
      }

      previousActiveId = id;
    });

    /*
      MODULE SECTIONS HANDLER  |  onScroll Event
    */
    MessageBus.subscribe('SECTIONS_HANDLER', ({ module, scrollEvent }) => {
      if (module.classList.contains(IS_SCROLLTO)) return;


      const sections = $$(`${SELECTOR}__section`, module);
      const navTop = $$(`${SELECTOR}__navigation`, module)[1].getBoundingClientRect().top;

      const isInView = (section) => {
        const bounds = section.getBoundingClientRect();
        const { top, bottom } = bounds;

        return (top <= getNavTop(module) && bottom >= getNavTop(module)) ? true : false;
      }



      const activeSection = sections.filter(section => isInView(section))[0];
      const id = activeSection ? activeSection.getAttribute('data-section-id') : null;


      activeSection && setActiveNavItem(module, id);
    });


    MessageBus.subscribe('SCROLLTO_SECTION_HANDLER', ({ target, id }) => {
      const module = target.closest(SELECTOR);
      const targetId = id || parseInt(target.getAttribute('data-nav-id'));
      const targetSection = $(`${SELECTOR}__section[data-section-id="${targetId}"]`, module);
      const targetTop = targetSection ? targetSection.getBoundingClientRect().top + window.scrollY : null;

      clearTimeout(isScrolling);
      module.classList.add(IS_SCROLLTO);
      isScrolling = setTimeout(() => {
        setElementFocus(targetSection);
        module.classList.remove(IS_SCROLLTO);
      }, 750);

      setActiveNavItem(module, targetId);
      

      if (targetSection) {
        window.scroll({
          top: targetTop,
          behavior: 'smooth'
        });
      }
    });


    MessageBus.subscribe('NAV_SKIP_BTN_HANDLER', ({ target }) => {
      const module = target.closest(SELECTOR);
      const nextModule = module.nextElementSibling;
      const marginBottom = parseInt(getComputedStyle(module).marginBottom.replace('px', ''));
      const targetTop = nextModule ? nextModule.getBoundingClientRect().top + window.scrollY - marginBottom : null;

      clearTimeout(isScrolling);
      module.classList.add(IS_SCROLLTO);
      isScrolling = setTimeout(() => {
        module.classList.remove(IS_SCROLLTO);
        setElementFocus(nextModule);
      }, 1000);

      if (nextModule) {
        window.scroll({
          top: targetTop,
          behavior: 'smooth'
        });
      }
    });


    MessageBus.subscribe('MEDIA_ANIMATION_HANDLER', ({ target }) => {
      // return;
      const parentSection = target.parentNode;
      const mediaItemCount = $$(`${SELECTOR}__media`, parentSection).length;

      if (mediaItemCount == 1) return;


      const targetChild = $(`${SELECTOR}__animation`, target);
      const { minWidth } = getComputedStyle(targetChild);
      const { top } = target.getBoundingClientRect();
      const isAlignRight = target.classList.contains('--align-right');
      const triggerOffset = isAlignRight ? window.innerHeight - 100 : 100;
      const width = triggerOffset - top;


      if (isAlignRight) {
        targetChild.style.setProperty('--width', `calc(${minWidth} + ${width}px)`);  
      } 
      else {
        targetChild.style.setProperty('--width', `calc(100% - ${width}px)`);  
      }
    });
  },

  /**
   * 3. RENDERING
   *
   * Use `finalize` for actions that should run
   * as soon as the module is rendered to the page
   * - e.g. Event Listeners, DOM Manipulations,
   *        MessageBus Publishers, etc
   */
  finalize(GlobalEvents, MessageBus) {
    const { onScroll, onResize, debounced } = GlobalEvents;
    console.log('storyscape finalize');

    smoothscroll.polyfill();

    INSTANCES.forEach(instance => {
      MessageBus.publish('NAV_VERTICAL_SCROLL_HANDLER', { module: instance });
      mediaItems.forEach(item => MessageBus.publish('MEDIA_ANIMATION_HANDLER', { target: item }));

      onResize(resizeEvent => MessageBus.publish('SECTIONS_HANDLER', { module: instance }));
      onScroll(scrollEvent => MessageBus.publish('SECTIONS_HANDLER', { module: instance, scrollEvent: scrollEvent }));
    });


    navItems.forEach(item => item.addEventListener('click', event => MessageBus.publish('SCROLLTO_SECTION_HANDLER', { target: item })));
    skipBtn.forEach(item => item.addEventListener('click', event => MessageBus.publish('NAV_SKIP_BTN_HANDLER', { target: item })));
    dropdown.forEach(item => item.addEventListener('change', event => MessageBus.publish('NAV_DROPDOWN_HANDLER', event)));
    mediaItems.forEach(item => onScroll(scrollEvent => MessageBus.publish('MEDIA_ANIMATION_HANDLER', { target: item })));

  },
};



// WEBPACK FOOTER //
// ../views/modules/storyscape/storyscape.js